import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const ThirdPartyRequestListItem = ({
  businessName,
  service,
  status,
  email,
  cellNumber,
  onRequestClick,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onRequestClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: 50,
        width: "100%",
        backgroundColor: hover ? colors.greenLight50 : colors.white,
        marginTop: 0.5,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        transition: "all 0.3s",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          flex: 0.2,
          color: null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> {businessName}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          //   color: hover ? colors.white : null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> {service}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          //   color: hover ? colors.white : null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> {email}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          //   color: hover ? colors.white : null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> {cellNumber}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          //   color: hover ? colors.white : null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> {status}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          //   color: hover ? colors.white : null,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BaseButtons
            label={"VIEW REQUEST"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            // onClick={onRequestClick}
            height={30}
            width={120}
          />
        </div>
      </div>
    </div>
  );
};

export default ThirdPartyRequestListItem;
